<template>
  <footer class="footer">
    <div class="footer-container">

      <!-- 主要内容区域 -->
      <div class="main-content">
      
        <!-- 左侧：股票信息和核心优势 -->
        <div class="left-section">
         <!-- 企业荣誉部分 -->
      <div class="honors-section">
        <div class="honor-item">
          <span>国家级高新技术企业</span>
        </div>
        <div class="honor-item">
          <span>中国广告一级企业</span>
        </div>
        <div class="honor-item">
          <span>中国AAA级信用企业</span>
        </div>
        <div class="honor-item">
          <span>专精特新小巨人企业</span>
        </div>
      </div>
          <div class="stock-info">
            <p>股票简称: 华视集团控股</p>
            <p>股票代码: 1111. HK</p>
          </div>
          
          <div class="core-advantages">
            <div class="blue-bar"></div>
            <div class="advantages-title">
              <span>五大核心优势: 品牌战略、广告创意、数字营销、大数据智库、AI科技</span>
              <span>前沿高校研究资源+营销策划实战团队</span>
              <span>为客户提供全生命周期的品牌解决方案和整合营销服务</span>
            </div>
      
          </div>
        </div>

        <!-- 右侧：导航链接 -->
        <div class="right-section">
          <div class="nav-column">
            <h4>解决方案</h4>
            <ul>
              <li><router-link :to="{ name: 'Solutions' }">数字人形象定制</router-link></li>
              <li><router-link :to="{ name: 'Solutions' }">数字人短视频</router-link></li>
              <li><router-link :to="{ name: 'Solutions' }">数字人交互系统</router-link></li>
              <li><router-link :to="{ name: 'Solutions' }">AIGC视频制作</router-link></li>
              <li><router-link :to="{ name: 'Solutions' }">AI屏型机器人</router-link></li>
              <li><router-link :to="{ name: 'Solutions' }">AI随身秘书</router-link></li>
            </ul>
          </div>
          
          <div class="nav-column">
            <h4>关于华视</h4>
            <ul>
              <li><router-link :to="{ name: 'About' }">企业简介</router-link></li>
              <li><router-link :to="{ name: 'About' }">发展历程</router-link></li>
              <li><router-link :to="{ name: 'About' }">企业资质</router-link></li>
              <li><router-link :to="{ name: 'About' }">合作伙伴</router-link></li>
              <li><router-link :to="{ name: 'About' }">加入我们</router-link></li>
            </ul>
          </div>
          
          <div class="nav-column">
            <h4>联系我们</h4>
            <div class="contact-info">
              <p class="phone">027-87715115</p>
              <div class="qr-codes">
                <div class="qr-item">
                  <div class="qr-code wechat-qr">
                    <img src="@/assets/image/QRcode.png" alt="华视说公众号二维码" />
                  </div>
                  <span>华视说公众号</span>
                </div>
                <div class="qr-item">
                  <div class="qr-code douyin-qr"></div>
                  <span>华视官方抖音</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部地址和版权 -->
      <div class="footer-bottom">
        <div class="address">
          <p>地址: 武汉市武昌区东湖南路7号/深圳市宝安区科兴科技园3号楼401</p>
        </div>
        <div class="copyright">
          <p>Copyright ©2025 华视中广国际传媒(武汉)有限责任公司版权所有 鄂ICP备19009271号-3</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #1a2332;
  color: #ffffff;
  margin-top: auto;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 企业荣誉部分 */
.honors-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 30px 0;
  border-bottom: 1px solid #2a3a4a;
}

.honor-item {
  position: relative;
  padding: 15px 0;
}

.honor-item span {
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  display: inline-block;
  position: relative;
}

.honor-item span::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: -6px;
  display: block;
  width: 100px;
  height: 12px;
  background: url('@/assets/image/title_line.png') no-repeat left center;
  background-size: 100% auto;
}

/* 主要内容区域 */
.main-content {
  display: flex;
  gap: 60px;
  padding: 40px 0;
  border-bottom: 1px solid #2a3a4a;
}

.left-section {
  flex: 1;
}

.right-section {
  flex: 1;
  display: flex;
  gap: 40px;
}

/* 股票信息 */
.stock-info {
  margin-bottom: 30px;
}

.stock-info p {
  color: #ffffff;
  margin: 8px 0;
  font-size: 14px;
}

/* 核心优势 */
.core-advantages {
  position: relative;
  display: flex;
  flex-direction: row;
}

.advantages-title {
  display: flex;
  margin-bottom: 15px;
  flex-direction: column;
}

.blue-bar {
  background: url('@/assets/image/title_line.png') no-repeat left center;
  width: 90px;
  background-size: 100% auto;
  margin-right: -21px;
  rotate: 90deg;
  margin-left: -44px;
}

.advantages-title span {
  color: #ffffff;
  font-size: 14px;
}

.core-advantages p {
  color: #ffffff;
  font-size: 14px;
  line-height: 1.6;
  margin: 8px 0;
}

/* 导航列 */
.nav-column {
  flex: 1;
}

.nav-column h4 {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 1px solid #2a3a4a;
  padding-bottom: 10px;
}

.nav-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-column ul li {
  margin-bottom: 12px;
}

.nav-column ul li a {
  background: linear-gradient(to bottom, #F0F7FD, #93BEEB);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
}

.nav-column ul li a:hover {
  background: linear-gradient(to bottom, #007bff, #0056b3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 联系信息 */
.contact-info .phone {
  color: #ffffff;
  font-size: 24px;
  margin-bottom: 20px;
}

.qr-codes {
  display: flex;
  gap: 20px;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.qr-code {
  width: 108px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.wechat-qr {
  background: transparent;
  padding: 0;
}

.wechat-qr img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.douyin-qr {
  background: url('@/assets/image/douyin_qr.png') no-repeat center center;
  background-size: cover;
}

/* 去除装饰伪元素，使用实图填充 */

.qr-item span {
  color: #cccccc;
  font-size: 12px;
  text-align: center;
}

/* 底部区域 */
.footer-bottom {
  padding: 20px 0;
  text-align: center;
}

.address p {
  color: #748EA6;
  font-size: 14px;
  margin-bottom: 10px;
}

.copyright p {
  color: #748EA6;
  font-size: 12px;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .main-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .right-section {
    flex-direction: column;
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .honors-section {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 20px 0;
  }
  
  .main-content {
    padding: 30px 0;
  }
  
  .qr-codes {
    justify-content: center;
  }
  
  .footer-container {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .honor-item span {
    font-size: 18px;
  }
  
  .nav-column h4 {
    font-size: 14px;
  }
  
  .nav-column ul li a {
    font-size: 13px;
  }
  
  .contact-info .phone {
    font-size: 14px;
  }
}
</style>
